import React from 'react'
import LoginForm from "./loginForm/LoginForm";
import './login.css'
import { Row, Col } from "antd";

const Login = () => {
    return (
        <React.Fragment>
            <Row justify={"center"} align={"middle"}>
                <Col span={24} lg={8} xl={8}>
                    <div className={'leftHand'}>

                    </div>
                </Col>
                <Col span={24} lg={16} xl={16}>
                    <div className={'rightHand'}>
                        <LoginForm/>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Login